// extracted by mini-css-extract-plugin
export var centerText = "_ed-8";
export var container = "_ed-0";
export var doughnutContainer = "_ed-7";
export var legend = "_ed-a";
export var legendItemColorDisplay = "_ed-b";
export var legendItemLabel = "_ed-d";
export var legendItemValue = "_ed-c";
export var lg = "_ed-5";
export var maxWidth = "_ed-9";
export var md = "_ed-4";
export var responsive = "_ed-6";
export var sm = "_ed-3";
export var xs = "_ed-2";
export var xxs = "_ed-1";